;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import { LOCALES } from '@/i18nConfig';
import { Lang } from '@/types/locales';

// Locales available for account pages
export const ACCOUNT_AVAILABLE_LOCALES: (typeof LOCALES)[keyof typeof LOCALES][] = [
  LOCALES.EN_CA,
  LOCALES.EN_AU,
  LOCALES.EN_NZ,
  ...(LOCALES.FR_CA ? [LOCALES.FR_CA] : []),
] as const;

export const LOCALES_MAP: Record<string, string> = {
  [LOCALES.EN_CA]: 'Canada (EN)',
  [LOCALES.EN_AU]: 'Australia (EN)',
  [LOCALES.EN_NZ]: 'New Zealand (EN)',
  [LOCALES.EN_HK]: 'Hong Kong (EN)',
  ...(LOCALES.EN_PL ? { [LOCALES.EN_PL]: 'Poland (EN)' } : {}),
  ...(LOCALES.FR_CA ? { [LOCALES.FR_CA]: 'Canada (FR)' } : {}),
  ...(LOCALES.PL_PL ? { [LOCALES.PL_PL]: 'Poland (PL)' } : {}),
  ...(LOCALES.ZH_HK ? { [LOCALES.ZH_HK]: 'Hong Kong (ZH)' } : {}),
};

export const COUNTRIES_MAP: Record<string, string> = {
  [LOCALES.EN_CA]: 'Canada',
  [LOCALES.FR_CA]: 'Canada',
  [LOCALES.EN_AU]: 'Australia',
  [LOCALES.EN_NZ]: 'New Zealand',
  [LOCALES.ZH_HK]: 'Hong Kong',
  [LOCALES.EN_HK]: 'Hong Kong',
  [LOCALES.EN_PL]: 'Poland',
  [LOCALES.PL_PL]: 'Poland',
};

export const LANGUAGES_MAP: Record<string, string> = {
  [LOCALES.EN_AU]: 'English',
  [LOCALES.EN_CA]: 'English',
  [LOCALES.EN_NZ]: 'English',
  [LOCALES.EN_HK]: 'English',
  [LOCALES.EN_PL]: 'English',
  [LOCALES.PL_PL]: 'Polski',
  [LOCALES.ZH_HK]: '繁體中文',
  [LOCALES.FR_CA]: 'Français',
};

export const LANGUAGE_CODES_MAP: Record<string, string> = {
  [LOCALES.EN_AU]: 'EN',
  [LOCALES.EN_CA]: 'EN',
  [LOCALES.EN_NZ]: 'EN',
  [LOCALES.EN_HK]: 'EN',
  [LOCALES.EN_PL]: 'EN',
  [LOCALES.PL_PL]: 'PL',
  [LOCALES.ZH_HK]: 'ZH',
  [LOCALES.FR_CA]: 'FR',
};

export interface CountryLanguageConfig {
  country: string;
  mainLocale: Lang;
  languages: {
    locale: Lang;
    name: string;
  }[];
}

export const COUNTRY_LANGUAGE_CONFIGS: CountryLanguageConfig[] = [
  {
    country: COUNTRIES_MAP[LOCALES.EN_AU],
    mainLocale: LOCALES.EN_AU as Lang,
    languages: [{ locale: LOCALES.EN_AU as Lang, name: LANGUAGES_MAP[LOCALES.EN_AU] }],
  },
  {
    country: COUNTRIES_MAP[LOCALES.EN_CA],
    mainLocale: LOCALES.EN_CA as Lang,
    languages: [
      { locale: LOCALES.EN_CA as Lang, name: LANGUAGES_MAP[LOCALES.EN_CA] },
      ...(LOCALES.FR_CA
        ? [{ locale: LOCALES.FR_CA as Lang, name: LANGUAGES_MAP[LOCALES.FR_CA] }]
        : []),
    ],
  },
  {
    country: COUNTRIES_MAP[LOCALES.EN_HK],
    mainLocale: LOCALES.EN_HK as Lang,
    languages: [
      ...(LOCALES.ZH_HK
        ? [{ locale: LOCALES.ZH_HK as Lang, name: LANGUAGES_MAP[LOCALES.ZH_HK] }]
        : []),
      { locale: LOCALES.EN_HK as Lang, name: LANGUAGES_MAP[LOCALES.EN_HK] },
    ],
  },
  {
    country: COUNTRIES_MAP[LOCALES.EN_NZ],
    mainLocale: LOCALES.EN_NZ as Lang,
    languages: [{ locale: LOCALES.EN_NZ as Lang, name: LANGUAGES_MAP[LOCALES.EN_NZ] }],
  },
  {
    country: COUNTRIES_MAP[LOCALES.PL_PL],
    mainLocale: LOCALES.PL_PL as Lang,
    languages: [
      ...(LOCALES.EN_PL
        ? [{ locale: LOCALES.EN_PL as Lang, name: LANGUAGES_MAP[LOCALES.EN_PL] }]
        : []),
      ...(LOCALES.PL_PL
        ? [{ locale: LOCALES.PL_PL as Lang, name: LANGUAGES_MAP[LOCALES.PL_PL] }]
        : []),
    ],
  },
];

export const COUNTRY_TO_LOCALE_MAP: Record<string, string> = {
  Canada: LOCALES.EN_CA,
  Australia: LOCALES.EN_AU,
  'New Zealand': LOCALES.EN_NZ,
  'Hong Kong': LOCALES.EN_HK,
  Poland: LOCALES.PL_PL,
};

export const PHONE_COUNTRY_CODES = {
  [LOCALES.EN_CA]: '1',
  [LOCALES.EN_AU]: '61',
  [LOCALES.EN_NZ]: '64',
  [LOCALES.EN_HK]: '852',
  [LOCALES.ZH_HK]: '852',
  ...(LOCALES.FR_CA ? { [LOCALES.FR_CA]: '1' } : {}),
  ...(LOCALES.EN_PL ? { [LOCALES.EN_PL]: '48' } : {}),
  ...(LOCALES.PL_PL ? { [LOCALES.PL_PL]: '48' } : {}),
} as const;

export const PHONE_EXPECTED_LENGTHS = {
  [LOCALES.EN_CA]: 11, // +1 + 10 digits
  [LOCALES.EN_AU]: 11, // +61 + 9 digits (min)
  [LOCALES.EN_NZ]: 11, // +64 + do 10 digits
  [LOCALES.EN_HK]: 11, // +852 + 8 digits (min)
  ...(LOCALES.EN_PL ? { [LOCALES.EN_PL]: 11 } : {}), // +48 + 9 digits
  [LOCALES.ZH_HK]: 11, // +852 + 8 digits (min)
  ...(LOCALES.FR_CA ? { [LOCALES.FR_CA]: 11 } : {}), // +1 + 10 digits
  ...(LOCALES.PL_PL ? { [LOCALES.PL_PL]: 11 } : {}), // +48 + 9 digits
} as const;

// Poland is sell-restricted: we are not permitted to sell in the EU right now, so the
// `preSell` documents for en-pl and pl-pl were unpublished in Prismic. The links were
// already taken off the site, but bookmarked URLs kept reaching the form and people
// kept transacting, so the route itself has to 404. Do not "fix" this by republishing
// the documents. The build failure it also caused (getSingle rejects on an empty
// result, which fails the prerender) is the symptom, not the reason.
export const PRE_SELL_EXCLUDED_LOCALES = [
  LOCALES.ZH_HK,
  LOCALES.EN_HK,
  LOCALES.PL_PL,
  LOCALES.EN_PL,
];

export const E_TRANSFER_EXCLUDED_LOCALES = [
  LOCALES.ZH_HK,
  LOCALES.EN_HK,
  LOCALES.PL_PL,
  LOCALES.EN_PL,
  LOCALES.EN_NZ,
];

export const KYC_EXCLUDED_LOCALES = [LOCALES.ZH_HK, LOCALES.EN_HK];

export const E_BUY_ALLOWED_LOCALES = [LOCALES.EN_CA, ...(LOCALES.FR_CA ? [LOCALES.FR_CA] : [])];
